// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as IndexRouteImport } from './app/index'
import { Route as R404RouteImport } from './app/404'
import { Route as BlogIndexRouteImport } from './app/blog/index'
import { Route as BlogDiscordAccountHackedRecoveryRouteImport } from './app/blog/discord-account-hacked-recovery'
import { Route as BlogHowDiscordSpamDetectionWorksRouteImport } from './app/blog/how-discord-spam-detection-works'
import { Route as BlogHowHoneypotSystemsWorkRouteImport } from './app/blog/how-honeypot-systems-work'
import { Route as BlogWhatIsAHoneypotRouteImport } from './app/blog/what-is-a-honeypot'
import { Route as BlogWhyImNotWorriedAboutSpamBotsGettingSmarterRouteImport } from './app/blog/why-im-not-worried-about-spam-bots-getting-smarter'
import { Route as DocsIndexRouteImport } from './app/docs/index'
import { Route as DocsCommandsRouteImport } from './app/docs/commands'
import { Route as DocsConfigurationRouteImport } from './app/docs/configuration'
import { Route as DocsCreditsRouteImport } from './app/docs/credits'
import { Route as DocsFaqRouteImport } from './app/docs/faq'
import { Route as DocsHowItWorksRouteImport } from './app/docs/how-it-works'
import { Route as DocsSelfHostingRouteImport } from './app/docs/self-hosting'
import { Route as DocsSetupGuideRouteImport } from './app/docs/setup-guide'
import { Route as DocsTipsRouteImport } from './app/docs/tips'
import { Route as DocsLegalPrivacyRouteImport } from './app/docs/legal/privacy'
import { Route as DocsLegalTermsRouteImport } from './app/docs/legal/terms'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogDiscordAccountHackedRecoveryRoute = BlogDiscordAccountHackedRecoveryRouteImport.update({
            id: '/blog/discord-account-hacked-recovery',path: '/blog/discord-account-hacked-recovery',getParentRoute: () => rootRouteImport
          })
const BlogHowDiscordSpamDetectionWorksRoute = BlogHowDiscordSpamDetectionWorksRouteImport.update({
            id: '/blog/how-discord-spam-detection-works',path: '/blog/how-discord-spam-detection-works',getParentRoute: () => rootRouteImport
          })
const BlogHowHoneypotSystemsWorkRoute = BlogHowHoneypotSystemsWorkRouteImport.update({
            id: '/blog/how-honeypot-systems-work',path: '/blog/how-honeypot-systems-work',getParentRoute: () => rootRouteImport
          })
const BlogWhatIsAHoneypotRoute = BlogWhatIsAHoneypotRouteImport.update({
            id: '/blog/what-is-a-honeypot',path: '/blog/what-is-a-honeypot',getParentRoute: () => rootRouteImport
          })
const BlogWhyImNotWorriedAboutSpamBotsGettingSmarterRoute = BlogWhyImNotWorriedAboutSpamBotsGettingSmarterRouteImport.update({
            id: '/blog/why-im-not-worried-about-spam-bots-getting-smarter',path: '/blog/why-im-not-worried-about-spam-bots-getting-smarter',getParentRoute: () => rootRouteImport
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/docs/',path: '/docs/',getParentRoute: () => rootRouteImport
          })
const DocsCommandsRoute = DocsCommandsRouteImport.update({
            id: '/docs/commands',path: '/docs/commands',getParentRoute: () => rootRouteImport
          })
const DocsConfigurationRoute = DocsConfigurationRouteImport.update({
            id: '/docs/configuration',path: '/docs/configuration',getParentRoute: () => rootRouteImport
          })
const DocsCreditsRoute = DocsCreditsRouteImport.update({
            id: '/docs/credits',path: '/docs/credits',getParentRoute: () => rootRouteImport
          })
const DocsFaqRoute = DocsFaqRouteImport.update({
            id: '/docs/faq',path: '/docs/faq',getParentRoute: () => rootRouteImport
          })
const DocsHowItWorksRoute = DocsHowItWorksRouteImport.update({
            id: '/docs/how-it-works',path: '/docs/how-it-works',getParentRoute: () => rootRouteImport
          })
const DocsSelfHostingRoute = DocsSelfHostingRouteImport.update({
            id: '/docs/self-hosting',path: '/docs/self-hosting',getParentRoute: () => rootRouteImport
          })
const DocsSetupGuideRoute = DocsSetupGuideRouteImport.update({
            id: '/docs/setup-guide',path: '/docs/setup-guide',getParentRoute: () => rootRouteImport
          })
const DocsTipsRoute = DocsTipsRouteImport.update({
            id: '/docs/tips',path: '/docs/tips',getParentRoute: () => rootRouteImport
          })
const DocsLegalPrivacyRoute = DocsLegalPrivacyRouteImport.update({
            id: '/docs/legal/privacy',path: '/docs/legal/privacy',getParentRoute: () => rootRouteImport
          })
const DocsLegalTermsRoute = DocsLegalTermsRouteImport.update({
            id: '/docs/legal/terms',path: '/docs/legal/terms',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,R404Route: R404Route,BlogDiscordAccountHackedRecoveryRoute: BlogDiscordAccountHackedRecoveryRoute,BlogHowDiscordSpamDetectionWorksRoute: BlogHowDiscordSpamDetectionWorksRoute,BlogHowHoneypotSystemsWorkRoute: BlogHowHoneypotSystemsWorkRoute,BlogWhatIsAHoneypotRoute: BlogWhatIsAHoneypotRoute,BlogWhyImNotWorriedAboutSpamBotsGettingSmarterRoute: BlogWhyImNotWorriedAboutSpamBotsGettingSmarterRoute,DocsCommandsRoute: DocsCommandsRoute,DocsConfigurationRoute: DocsConfigurationRoute,DocsCreditsRoute: DocsCreditsRoute,DocsFaqRoute: DocsFaqRoute,DocsHowItWorksRoute: DocsHowItWorksRoute,DocsSelfHostingRoute: DocsSelfHostingRoute,DocsSetupGuideRoute: DocsSetupGuideRoute,DocsTipsRoute: DocsTipsRoute,BlogIndexRoute: BlogIndexRoute,DocsIndexRoute: DocsIndexRoute,DocsLegalPrivacyRoute: DocsLegalPrivacyRoute,DocsLegalTermsRoute: DocsLegalTermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)